import { useState, useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { intersection_threshold, url } from '../../base/Variables'
import { LazyAxios } from '../../base'
import { ProductCard, ProductPlaceholder } from '../index'
import { useDispatch } from 'react-redux'
import { setSuggestedProduct } from '../../redux/AppSlice'
import { useNavigate } from 'react-router-dom'

function NewProduct() {
  const [loading, setLoading] = useState(true)
  const new_product = useSelector((state) => state.appSlice.new_product)
  const cart_item_list = useSelector((state) => state.cartSlice.cart_item_list)
  const dispatch = useDispatch()
  const componentRef = useRef(null)
  const navigate = useNavigate()
  const baseUrl = `${url}/api/v1/product`

  async function getNewProducts() {
    setLoading(true)
    try {
      const axios = await LazyAxios()
      const request = await axios.get(`${baseUrl}/getNewProducts/`)
      if (request.data && request.data.data) {
        dispatch(setSuggestedProduct({ 'type': 'new_product', 'data': request.data.data }))
      }
      console.log(request.data)
      setLoading(false)
    }
    catch (error) {
      setLoading(false)
      console.log(error)
    }

  }
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        // Check if the child component is in the viewport
        if (entries[0].isIntersecting && loading) {
          // Trigger the API call or any function passed as prop
          if (new_product === null) {
            getNewProducts()
          }
          else {
            setLoading(false)
          }
        }
      },
      {
        root: null, // default to the viewport
        threshold: intersection_threshold, // 50% of the component must be visible
      }
    );

    if (componentRef.current) {
      observer.observe(componentRef.current);
    }

    return () => {
      if (componentRef.current) {
        observer.unobserve(componentRef.current);
      }
    };
  }, [new_product, loading])


  return (

    <div className='mt-5 container' ref={componentRef}>
      {
        loading ? <ProductPlaceholder /> :
          new_product ? <>
            <div className='h4 heading '>Brand New, Just for You</div>
            <div style={{ display: 'flex', gap: '30px', width: '100%', marginTop: '50px', overflowX: 'scroll', scrollbarWidth: 'none' }}>
              {
                new_product.map((item, index) => {
                  return <div key={index}>
                    <ProductCard product={item} added={cart_item_list[`p${item.id}`] ? true : false} />
                  </div>
                })
              }
            </div>
            <div className='text-center'><button onClick={() => navigate('/p/shop/all/category/all/products/')} className='primaryButton' style={{ width: '130px' }}>See All</button></div>
            <hr className='mt-5' />
          </> : <></>
      }
    </div>
  )
}

export default NewProduct